// General Info TAB
export const ID = "id";
export const CODE = "code";
export const DESCRIPTION = "description";
export const ASSET_MODEL_VISUALIZATION = "assetModelTypeVisualizationTypeId";
